import { configResponsive, useResponsive } from 'ahooks'
import classNames from 'classnames'
import { useEffect, useState } from 'react'
import useI18n from 'src/hooks/use_i18n'
import 'swiper/css'
import 'swiper/css/autoplay'
import 'swiper/css/navigation'
import 'swiper/css/pagination'
import { A11y, Autoplay, Navigation, Pagination } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/react'
import styles from './index.module.scss'

configResponsive({
  xs: 0,
  sm: 768,
  md: 992,
  large: 1200
})

export default function Comment() {
  const { $t } = useI18n()
  const responsive = useResponsive()
  const [slidesPerView, setSlidesPerView] = useState(4)
  const [activeIndex, setActiveIndex] = useState<number>(0)
  const [commentList] = useState<Record<'nick_name' | 'score' | 'time' | 'desc' | 'star', string>[]>([
    {
      nick_name: 'Wintolife',
      star: '⭐️⭐️⭐️⭐️⭐️',
      score: '5.0',
      time: $t('ResWwwPTrackCenterLP.global.__comment_comment1Time'),
      desc: $t('ResWwwPTrackCenterLP.global.__comment_comment1Desc')
    },
    {
      nick_name: 'AmazingOutlets',
      star: '⭐️⭐️⭐️⭐️⭐️',
      score: '5.0',
      time: $t('ResWwwPTrackCenterLP.global.__comment_comment2Time'),
      desc: $t('ResWwwPTrackCenterLP.global.__comment_comment2Desc')
    },
    {
      nick_name: 'Firstbea',
      star: '⭐️⭐️⭐️⭐️⭐️',
      score: '5.0',
      time: $t('ResWwwPTrackCenterLP.global.__comment_comment3Time'),
      desc: $t('ResWwwPTrackCenterLP.global.__comment_comment3Desc')
    },
    {
      nick_name: 'lspbaodan',
      star: '⭐️⭐️⭐️⭐️⭐️',
      score: '5.0',
      time: $t('ResWwwPTrackCenterLP.global.__comment_comment4Time'),
      desc: $t('ResWwwPTrackCenterLP.global.__comment_comment4Desc')
    },
    {
      nick_name: 'FUGOLEAR',
      star: '⭐️⭐️⭐️⭐️⭐️',
      score: '5.0',
      time: $t('ResWwwPTrackCenterLP.global.__comment_comment5Time'),
      desc: $t('ResWwwPTrackCenterLP.global.__comment_comment5Desc')
    },
    {
      nick_name: 'Flashwalk-eCom',
      star: '⭐️⭐️⭐️⭐️⭐️',
      score: '5.0',
      time: $t('ResWwwPTrackCenterLP.global.__comment_comment6Time'),
      desc: $t('ResWwwPTrackCenterLP.global.__comment_comment6Desc')
    }
  ])

  useEffect(() => {
    const { large, md, sm } = responsive
    setSlidesPerView(large ? 4 : md ? 3 : sm ? 2 : 1)
  }, [responsive])

  useEffect(() => {
    try {
      const $prev = document.querySelector('.swiper-button-prev') as HTMLDivElement
      const $next = document.querySelector('.swiper-button-next') as HTMLDivElement

      $prev.classList.add('fa-chevron-left')
      $next.classList.add('fa-chevron-right')
    } catch (error) {
      console.log(error)
    }
  }, [])

  return (
    <section className={classNames(styles.comment)}>
      <div className={styles.wrapper}>
        <h2 className={classNames(styles.title)}>
          {$t('ResWwwPTrackCenterLP.global.__section4_trustByShopifySeller')}
        </h2>
        <Swiper
          spaceBetween={30}
          slidesPerView={slidesPerView}
          modules={[Navigation, Pagination, A11y, Autoplay]}
          pagination={{ clickable: true }}
          navigation={{
            enabled: true,
            disabledClass: 'swiper-disabled-class'
          }}
          scrollbar={{ draggable: true }}
          onSlideChange={(swiper) => setActiveIndex(swiper.activeIndex)}
        >
          {commentList.map((ele, idx) => (
            <SwiperSlide key={idx}>
              <div
                className={classNames(styles['slide-info'], {
                  [styles['linear-gradient']]:
                    // responsive?.large &&
                    (activeIndex === 0 && idx === 3) || (activeIndex === 1 && idx === 4)
                })}
              >
                <h2>{ele.nick_name}</h2>
                <div className="flex items-center">
                  <span className={styles.star}>{ele.star}</span>
                  <span className={classNames('ml-2.5', styles.score)}>{ele.score}</span>
                </div>
                <p className={styles.time}>{ele.time}</p>
                <p className={styles.desc}>{ele.desc}</p>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </section>
  )
}
